export default __webpack_public_path__ + "static/assets/0a038ef89d19e7f7acaf4b444c609e1a.jpg";